import Chips from './Chips';

export default Chips;
